<template>
  <ErrorBoundary>
    <Card class="p-2.5 rounded-2xl">
      <div class="card-body text-center">
        <div>
          <h6 class="text-left text-[1.125rem]">
            {{ getRequestCardTitle() }}
          </h6>
          <p class="mt-2 text-left text-sm">
            {{
              eventGetters.isBoxEvent(eventData)
                ? t('product.show.checkout.teamEvent.boxDescription')
                : t('product.show.checkout.teamEvent.description')
            }}
          </p>
        </div>

        <Select
          v-if="eventGetters.getHasMobileClasses(eventData)"
          v-model="selectedLocation"
          class="mt-4"
          :options="locationOptions"
          :transformer-fn="
            (option: EventLocationSelectOption, idx: number) => ({
              id: idx,
              label: option.label,
              value: option.value,
            })
          "
          size="default"
        />

        <Button
          variant="outlined"
          class="p-2 w-full mt-4 group py-2.5"
          data-test-id="contact-us-button"
          @click="
            toggleDateRequestSidebar(
              route.name,
              'teamevent_box',
              selectedLocation.value
            )
          "
        >
          <span class="flex justify-center items-center relative gap-1">
            <IconPeopleFill
              class="w-6 h-6 text-white hidden [&>path]:fill-current transition-opacity duration-200 opacity-0 group-hover:opacity-100 group-hover:block"
            />
            <IconPeopleStroke
              class="w-6 h-6 text-teal-900 [&>path]:fill-current transition-opacity duration-200 group-hover:opacity-0 group-hover:hidden"
            />
            <span>
              {{
                eventGetters.isBoxEvent(eventData)
                  ? t('teamEvents.button.boxLabel')
                  : t('teamEvents.button.label')
              }}
            </span>
            &gt;
          </span>
        </Button>
      </div>
    </Card>
  </ErrorBoundary>
</template>
<script setup lang="ts">
import IconPeopleStroke from '~/assets/icons/event/people.svg?component'
import IconPeopleFill from '~/assets/icons/event/people-fill.svg?component'
import type { EventDescription } from '~/composables/types/event'
import Select from '~/components/common/Select.vue'

export type EventLocationPreference = 'user_location' | 'partner_location'

type EventLocationSelectOption = {
  value: EventLocationPreference
  label: string
}
const { toggleDateRequestSidebar } = useUiState()
const route = useRoute()

const { price } = defineProps<{ price: string | boolean }>()

const { t } = useI18n()

const eventData = inject<ComputedRef<EventDescription>>('eventData')!

const locationOptions = computed<EventLocationSelectOption[]>(() => [
  {
    value: 'partner_location',
    label: t('product.eventLocation.partnerLocation', {
      eventLocation: eventGetters.getAddressLocalityName(eventData),
    }),
  },

  {
    value: 'user_location',
    label: t('product.eventLocation.userLocation'),
  },
])

const getRequestCardTitle = () => {
  if (eventGetters.isBoxEvent(eventData)) {
    return t('product.show.checkout.teamEvent.boxTitle')
  }
  if (price && eventGetters.isGroupPricing(eventData)) {
    return t('product.show.checkout.teamEvent.titleWithGroupPrice', {
      price: price,
    })
  }
  if (price) {
    return t('product.show.checkout.teamEvent.titleWithPrice', { price: price })
  }
  return t('product.show.checkout.teamEvent.title')
}

const selectedLocation = ref(locationOptions.value[0])
</script>
